const DownloadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
);
const FileIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
    </svg>
);
const AlertIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
);

const Downloads = ({ attributes }) => {
    const { downloads } = attributes;

    return (
        <div className="gmf-page-wrapper">
            {/* Page Title */}
            <section className="gmf-page-hero">
                <div className="gmf-page-hero-inner">
                    <p className="gmf-page-eyebrow gmf-accent-color">{downloads.subtitle}</p>
                    <h1 className="gmf-page-title">{downloads.title}</h1>
                    <div className="gmf-divider gmf-divider--center" />
                    <p className="gmf-page-subtitle">{downloads.pageSubtitle}</p>
                </div>
            </section>

            {/* Downloads List */}
            <section className="gmf-downloads-section">
                <div className="gmf-section-container">
                    <div className="gmf-downloads-grid">
                        {downloads.items.map((item, index) => {
                            const hasFile = item.fileUrl && item.fileUrl !== '#' && item.fileUrl !== '';
                            return (
                                <div key={index} className="gmf-download-card gmf-card">
                                    {/* Icon + type badge */}
                                    <div className="gmf-download-icon-wrap">
                                        <span className="gmf-accent-color"><FileIcon /></span>
                                        <span className="gmf-download-type">{item.fileType || 'PDF'}</span>
                                    </div>

                                    {/* Info */}
                                    <div className="gmf-download-info">
                                        <h3 className="gmf-download-name">{item.name}</h3>
                                        <p className="gmf-download-desc">{item.description}</p>
                                        {item.fileName && (
                                            <p className="gmf-download-filename">
                                                📎 {item.fileName}
                                            </p>
                                        )}
                                        {!hasFile && (
                                            <p className="gmf-download-unavailable">
                                                <span><AlertIcon /></span>
                                                File not uploaded yet
                                            </p>
                                        )}
                                    </div>

                                    {/* Download button */}
                                    {hasFile ? (
                                        <a
                                            href={item.fileUrl}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                            className="gmf-download-btn gmf-btn-primary"
                                            download={item.fileName || true}
                                        >
                                            <DownloadIcon />
                                            <span>Download</span>
                                        </a>
                                    ) : (
                                        <span className="gmf-download-btn gmf-download-btn--disabled">
                                            <DownloadIcon />
                                            <span>Unavailable</span>
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Downloads;
